<template>
  <div v-show="dialogShow">
    <div class="point-set-dialog pb-5">
      <div class="flex items-center mb-5px">
        <span class="w-2px h-16px bg-$buttonPrimaryBg inline-block mr-10px"></span>
        <span class="text-16px text-$titleTextColor">位置设置</span>
      </div>
      <el-form
        class="form-height"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="110px"
        size="small"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="名称" class="width-80"></el-input>
        </el-form-item>
        <el-form-item label="编码" prop="code">
          <el-input v-model="ruleForm.code" placeholder="设备编码" class="width-80"></el-input>
        </el-form-item>
        <el-form-item label="关联模型" prop="model">
          <el-input
            v-model="ruleForm.model"
            placeholder="关联模型"
            class="width-80"
            readonly
          ></el-input>
          <el-button type="primary" class="ml-2px" @click="modelSelect" :disabled="!modelLoaded"
            >关联模型</el-button
          >
        </el-form-item>
        <el-form-item label="位置">
          <div class="flex">
            <el-form-item label="" prop="xPoint">
              <el-input
                style="width: 120px;"
                class="mr-8px"
                placeholder="x"
                v-model="ruleForm.xPoint"
                readonly
              >
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="yPoint">
              <el-input
                style="width: 120px;"
                class="mr-8px"
                placeholder="y"
                v-model="ruleForm.yPoint"
                readonly
              >
              </el-input>
            </el-form-item>
            <el-form-item label="" prop="zPoint">
              <el-input
                style="width: 120px;"
                class="mr-2px"
                placeholder="z"
                v-model="ruleForm.zPoint"
                readonly
              >
              </el-input>
            </el-form-item>
            <el-button type="primary" @click="pointSelect" :disabled="!modelLoaded">选点</el-button>
          </div>
        </el-form-item>
        <el-form-item label="定位视角" v-if="deviceTypeInfo.showAngleView">
          <div class="flex">
            <el-form-item label="" prop="eye">
              <el-input
                style="width:60px"
                class="mr-8px"
                placeholder="eye"
                v-model="ruleForm.eye"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="target">
              <el-input
                style="width:60px"
                placeholder="target"
                class="mr-8px"
                v-model="ruleForm.target"
                readonly
              ></el-input>
            </el-form-item>
            <el-form-item label="" prop="up">
              <el-input
                style="width:60px"
                class="mr-2px"
                placeholder="up"
                v-model="ruleForm.up"
                readonly
              ></el-input>
            </el-form-item>
            <el-button type="primary" @click="getCamaraPosition" :disabled="!modelLoaded"
              >获取视角</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="区域高度" prop="height" v-if="deviceTypeInfo.showMonitorRange">
          <el-input
            v-model="railHeight"
            placeholder="区域高度"
            style="width:100px;"
            @change="changeAreaHeight"
            @keyup.enter.native="changeAreaHeight"
          ></el-input>
          <span class="ml-1">m</span>
        </el-form-item>
        <el-form-item label="绘制区域" prop="model" v-if="deviceTypeInfo.showMonitorRange">
          <el-button type="primary" size="small" @click="activateTool">
            {{ isActivateTool ? '取消手动绘制范围' : '手动绘制范围' }}
          </el-button>
        </el-form-item>
        <el-form-item label="有效范围" prop="points" v-if="deviceTypeInfo.showMonitorRange">
          <el-row
            class="mt-5px"
            type="flex"
            align="middle"
            v-for="(item, index) in ruleForm.points"
            :key="index + 's'"
          >
            <el-col :span="7" class="mr-5px">
              <el-input
                clearable
                size="small"
                class="w-full"
                v-model="item.xPoint"
                placeholder
                @keyup.enter.native="changeAreaPosition"
                @input="inputUpdate"
                @change="changeAreaPosition"
              ></el-input>
            </el-col>
            <el-col :span="7" class="mr-5px">
              <el-input
                clearable
                class="w-full"
                size="small"
                v-model="item.yPoint"
                placeholder
                @keyup.enter.native="changeAreaPosition"
                @input="inputUpdate"
                @change="changeAreaPosition"
              ></el-input>
            </el-col>
            <el-col :span="7" class="mr-5px">
              <el-input
                clearable
                class="w-full"
                v-model="item.zPoint"
                placeholder
                size="small"
                @keyup.enter.native="changeAreaPosition"
                @input="inputUpdate"
                @change="changeAreaPosition"
              ></el-input>
            </el-col>
            <el-col :span="7">
              <el-tooltip
                placement="top"
                content="删除"
                v-if="ruleForm.points.length > 1"
                :open-delay="1000"
              >
                <el-button
                  type="danger"
                  size="small"
                  class="mr-5px"
                  @click="removePositionVertex(index)"
                  icon="el-icon-minus"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                placement="top"
                content="新增"
                :open-delay="1000"
                v-if="index === ruleForm.points.length - 1"
              >
                <el-button
                  type="primary"
                  size="small"
                  class="ml-0px mr-5px"
                  icon="el-icon-plus"
                  @click="addPositionVertex"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="有效范围颜色" prop="model" v-if="deviceTypeInfo.showMonitorRange">
          <el-color-picker
            v-model="ruleForm.threeDMonitorRangeColor"
            @change="handleSelectColor"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="点位样式" prop="pointIcon">
          <el-popover ref="pointStylePopover" placement="bottom-start" width="350" trigger="click">
            <div class="style-menus">
              <div class="sec_cont_icon flex">
                <div
                  class="icon_cont ml-1"
                  v-for="(item, index) in basicIconList"
                  :key="index"
                  @click="chooseStyle(item)"
                >
                  <img-upload
                    class="rounded"
                    :uploadWidth="40"
                    :uploadHeight="40"
                    :isShowDeleteButton="false"
                    :isShowUpdate="false"
                    :fileId="item.fileId"
                  ></img-upload>
                </div>
              </div>
            </div>
            <el-input
              slot="reference"
              placeholder="请填写点位样式"
              readonly
              v-model="ruleForm.pointIcon"
            ></el-input>
          </el-popover>
        </el-form-item>
        <el-form-item label="图标" prop="model">
          <img v-if="currentIconUrl" style="width:30px; height:30px" :src="currentIconUrl" />
          <el-image
            v-else
            style="width:28px; height:28px; background:transparent;"
            :src="currentIconUrl"
            fit="fit"
          >
            <div slot="error" class="image-slot">
              <i style="width: 100%; height: 100%" class="el-icon-picture-outline"></i></div
          ></el-image>
        </el-form-item>
        <template v-if="!hiddenBuildingFloor">
          <el-form-item label="所属建筑" prop="">
            <el-select
              placeholder="请选择所属建筑"
              v-model="ruleFormNew.buildingName"
              filterable
              clearable
              @change="changeBuilding"
            >
              <el-option
                v-for="item in buildOption"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属楼层" prop="">
            <el-select
              placeholder="请选择所属楼层"
              v-model="ruleFormNew.floorName"
              filterable
              clearable
              :disabled="ruleFormNew.buildingName === ''"
              @change="changeFloor"
            >
              <el-option
                v-for="item in floorOption"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联设备" prop="">
            <el-input
              type="textarea"
              v-model="ruleFormNew.relevanceDevices"
              placeholder=""
              class="width-50"
              disabled
            ></el-input>
            <el-button type="primary" class="ml-2px" @click="relevanceDevicesSelect"
              >关联设备</el-button
            >
            <el-button type="primary" class="ml-2px" @click="relevanceDevicesClear"
              >清空关联</el-button
            >
          </el-form-item>
        </template>
      </el-form>

      <div class="flex justify-center items-center dialog-footer">
        <el-button
          type="primary"
          size="small"
          @click="confirm"
          :disabled="!$hasAccess('update')"
          :loading="saveLoading"
          >保存</el-button
        >
        <!-- <el-button size="small" @click="dataReset">重置</el-button> -->
        <el-button type="default" size="small" @click="cancelEdit">取消</el-button>
        <el-button type="default" size="small" @click="backPrevious">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BuildingApi, FloorApi } from '@wiz-api/personnel-position'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { Tag3DPositionApi, Tag3DPositionImgApi } from '@wiz-api/tag-3d-position-management'
import ImgUpload from './ImgUpload'

const tag3DPositionManagementAPI = new Tag3DPositionApi()
const tag3DPositionImgApi = new Tag3DPositionImgApi()
const buildingApi = new BuildingApi()
const floorApi = new FloorApi()
const iotDeviceApi = new IOTDeviceApi()

export default {
  props: {
    show: Boolean,
    type: {
      type: String,
      default: 'edit',
    },
    detailRow: Object,
    modelLoaded: Boolean,
    currentPosition: Array,
    player: Object,
    basicIconList: {
      type: Array,
      default: () => {
        return []
      },
    },
    relevanceDevices: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 设备类型的具体信息
    deviceTypeInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 点击了三维里某个点获取到的点位信息
    pointInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    // 下拉框参考参数
    modelFileId: {
      type: String,
      default: '',
    },
    // 场景id
    sceneId: {
      type: String,
      default: '',
    },
  },
  components: {
    ImgUpload,
  },
  data() {
    return {
      railHeight: 1,
      currentIcon: null,
      currentIconUrl: null,
      perspective: '',
      ruleForm: {
        xPoint: '',
        yPoint: '',
        zPoint: '',
        eye: '',
        target: '',
        up: '',
        pointIcon: '',
        threeDMonitorRangeColor: '',
        points: [
          {
            id: '',
            xPoint: 0,
            yPoint: 0,
            zPoint: 0,
          },
        ],
      },
      ruleFormNew: {
        id: this.detailRow.tag3DPositionRelationKey,
        buildingId: '',
        floorId: '',
        buildingName: '',
        floorName: '',
        relevanceDevices:
          this.relevanceDevices.length === 0 ? '' : `${this.relevanceDevices.join(',')},`,
      },
      buildOption: [],
      floorOption: [],
      rules: {
        // xPoint: [{ required: true, message: '请选择坐标', trigger: 'blur' }],
      },
      saveLoading: false,
      markerList: [],
      moduleAuth: null,
      timerOut: null, // 防抖
      isActivateTool: false, // 是否激活工具
      areaObject: null,
      createPillarPos: [], // 通过鼠标创建围栏时存放数据
      imagePtr: null, // 图片的指针
      selectPositionFlag: false, // 【选点】的标记
      relatedModel: false, // 关联模型的标记
    }
  },
  watch: {
    pointInfo: {
      handler(val) {
        if (val.object) {
          // 如果没有点击【选点】，或者点击过其它按钮selectPositionFlag为false，那么坐标不变
          if (!this.relatedModel) {
            return
          }
          this.ruleForm.model = val.object.name
          this.$forceUpdate()
        } else {
          this.ruleForm.model = ''
        }
      },
      deep: true,
    },
    currentPosition: {
      handler(val) {
        if (val.length) {
          // 如果没有点击【选点】，或者点击过其它按钮selectPositionFlag为false，那么坐标不变
          if (!this.selectPositionFlag) {
            return
          }
          this.ruleForm.xPoint = val[0]
          this.ruleForm.yPoint = val[1]
          this.ruleForm.zPoint = val[2]
          this.$forceUpdate()
        } else {
          this.ruleForm.xPoint = ''
          this.ruleForm.yPoint = ''
          this.ruleForm.zPoint = ''
        }
      },
      deep: true,
    },
    detailRow: {
      handler(val, oldVal) {
        if (oldVal && oldVal.code !== val.code) {
          this.initData()
        }
      },
      deep: true,
    },
    relevanceDevices(val) {
      const oldRelevanceDevices = this.ruleFormNew.relevanceDevices
        ? this.ruleFormNew.relevanceDevices.split(',')
        : []
      const newRelevanceDevices = val || []
      this.ruleFormNew.relevanceDevices = [
        ...oldRelevanceDevices,
        ...newRelevanceDevices.filter((item) => { return !oldRelevanceDevices.includes(item) }),
      ].join(',')
    },
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    title() {
      const map = {
        add: '新增',
        edit: '编辑',
        view: '查看',
      }
      return map[this.type]
    },
    isView() {
      return this.type === 'view'
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
    wizIotConfig() {
      return Wiz.globalSettings.dynamicModules?.modules['wiz-iot-management']?.config || {}
    },
    hiddenBuildingFloor() {
      return this.wizIotConfig.hiddenBuildingFloor
    }
  },
  methods: {
    initData() {
      // 判断是否有区域对象
      if (this.areaObject) {
        this.player.Native.ElectoronicRail.destroy(this.areaObject)
      }
      this.currentIconUrl = null // 显示的图标置为空
      this.ruleForm = _.cloneDeep(this.detailRow)
      console.log(this.ruleForm, '1208976y')
      console.log(this.modelFileId, '1208976y')
      this.getBuild()
      this.getFloor()
      if (this.deviceTypeInfo.code !== 'Cooperator') { // 合作商设备类型
        this.getNewForm()
      }
      let persp = JSON.parse(this.detailRow.threeDAngleView || '{}')
      let threeDPosition = []
      let threeDMonitorRange = []
      this.ruleForm.threeDMonitorRangeColor = ''
      this.railHeight = 1
      const tag3DPositionDto = this.detailRow.tag3DPositionDto
      if (tag3DPositionDto) {
        const position = tag3DPositionDto.threeDPosition
        const points = tag3DPositionDto.threeDMonitorRange
        persp = JSON.parse(tag3DPositionDto.threeDAngleView || '{}')
        threeDPosition = position ? JSON.parse(position) : []
        threeDMonitorRange = points ? JSON.parse(points) : []
        this.ruleForm.tagFileImgId = tag3DPositionDto.tagFileImgId
        this.ruleForm.threeDMonitorRangeColor = tag3DPositionDto.threeDMonitorRangeColor

        // 根据图标id获取图标名称和文件id(文件id用于获取图标显示)
        const iconId = tag3DPositionDto.tagFileImgId
        if (iconId) {
          this.getIconName(iconId)
        }
      }
      this.ruleForm.points = threeDMonitorRange
      // 如果设置了有效范围，在三维绘制体现
      if (Array.isArray(threeDMonitorRange) && threeDMonitorRange.length > 0) {
        this.drawArea()
      }
      // 解析位置
      if (Array.isArray(threeDPosition) && threeDPosition.length > 0) {
        this.ruleForm.xPoint = threeDPosition[0]
        this.ruleForm.yPoint = threeDPosition[1]
        this.ruleForm.zPoint = threeDPosition[2]
      }
      // 解析视角
      if (persp.eye) {
        this.ruleForm.eye = persp.eye.join()
        this.ruleForm.target = persp.target.join()
        this.ruleForm.up = persp.up.join()
        this.ruleForm.perspective = this.detailRow.threeDAngleView
        // this.player.Native.Camera.moveTo(persp.eye, persp.target, persp.up, 1)
      } else {
        this.ruleForm.eye = ''
        this.ruleForm.target = ''
        this.ruleForm.up = ''
        this.ruleForm.perspective = ''
      }
    },
    // 获取图标名称和显示
    async getIconName(id) {
      const [err, res] = await tag3DPositionImgApi.get(id)
      if (!err) {
        this.ruleForm.pointIcon = res.originalFileName
        this.getImgContent(res.fileId)
      }
    },
    // 有效范围取色
    handleSelectColor(res) {
      this.ruleForm.threeDMonitorRangeColor = res
    },
    // 选择样式
    chooseStyle(val) {
      this.$refs.pointStylePopover.showPopper = false
      this.ruleForm.pointIcon = val.originalFileName // 页面上【点位样式】，显示图标的名称，如：camera.png
      this.currentIcon = val.fileId
      this.ruleForm.tagFileImgId = val.id // 接口调用时用
      this.getImgContent(val.fileId) // 页面上【图标】，显示具体的图标
    },
    // 获取视角
    async getCamaraPosition() {
      this.selectPositionFlag = false
      this.relatedModel = false

      const res = await PlayerUtils.call(this.player.Native.Camera.currentParam)
      if (res) {
        this.ruleForm.eye = res.eye.join()
        this.ruleForm.target = res.target.join()
        this.ruleForm.up = res.up.join()
        this.perspective = res
        this.$forceUpdate()
      }
    },
    // 关联模型
    async modelSelect() {
      this.selectPositionFlag = false
      this.relatedModel = true
      const selectedItem = await this.player.Native.ModelTree.getSelectedItem()
      // console.log(selectedItem)
      if (selectedItem.item) {
        this.ruleForm.model = selectedItem.name
        this.$forceUpdate()
      } else {
        this.$message.warning('请选择模型')
      }
    },
    // 点选
    pointSelect() {
      this.selectPositionFlag = true
      this.relatedModel = false
    },
    confirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        // this.editBuildingFloor()
        if (valid) {
          if (this.detailRow.tag3DPositionDto) {
            // 如果存在tag3DPositionDto，则说明之前新增了信息
            this.editDeviceInfo()
          } else {
            this.addDeviceInfo()
          }
        }
      })
    },
    // 新增设备的配置信息
    async addDeviceInfo() {
      const res = await tag3DPositionManagementAPI.create({
        body: {
          tagTypeCode: this.deviceTypeInfo.code,
          name: this.ruleForm.name,
          code: this.ruleForm.code,
          relationKey: this.detailRow.tag3DPositionRelationKey,
          threeDModel: this.ruleForm.model,
          threeDPosition: this.ruleForm.xPoint
            ? JSON.stringify([this.ruleForm.xPoint, this.ruleForm.yPoint, this.ruleForm.zPoint])
            : '',
          threeDAngleView: this.perspective ? JSON.stringify(this.perspective) : '',
          threeDMonitorRange:
            this.ruleForm.points.length > 0 ? JSON.stringify(this.ruleForm.points) : '',
          tagFileImgId: this.ruleForm.tagFileImgId,
          threeDMonitorRangeColor: this.ruleForm.threeDMonitorRangeColor,
          sceneId: this.sceneId
        },
      })
      const opt = {
        ...this.ruleFormNew,
      }
      if (this.deviceTypeInfo.code === 'Cooperator') { // 合作商设备类型
        if (res[1]) {
          this.$message.success('保存成功')
          this.$emit('reload')
          this.dialogShow = false
          this.isActivateTool = false
          this.delDraw()
        }
        return
      }
      if (!opt.buildingId) delete opt.buildingId
      if (!opt.floorId) delete opt.floorId
      const [err2, res2] = await iotDeviceApi.updateIOTDeviceBuildingFloor({ body: opt })
      this.saveLoading = false
      if (res[1] && !err2) {
        this.$message.success('保存成功')
        this.$emit('reload')
        this.dialogShow = false
        this.isActivateTool = false
        this.delDraw()
      } else {
        this.$message.error('保存失败')
      }
    },
    // 编辑设备信息
    async editDeviceInfo() {
      const res = await tag3DPositionManagementAPI.update(this.detailRow.tag3DPositionDto.id, {
        body: {
          tagTypeCode: this.deviceTypeInfo.code,
          name: this.ruleForm.name,
          code: this.ruleForm.code,
          relationKey: this.detailRow.tag3DPositionRelationKey,
          threeDModel: this.ruleForm.model,
          tagFileImgId: this.ruleForm.tagFileImgId,
          threeDPosition: this.ruleForm.xPoint
            ? JSON.stringify([this.ruleForm.xPoint, this.ruleForm.yPoint, this.ruleForm.zPoint])
            : '',
          threeDAngleView: this.perspective ? JSON.stringify(this.perspective) : '',
          threeDMonitorRange:
            this.ruleForm.points.length > 0 ? JSON.stringify(this.ruleForm.points) : '',
          threeDMonitorRangeColor: this.ruleForm.threeDMonitorRangeColor,
          id: this.detailRow.tag3DPositionDto.id,
          sceneId: this.sceneId
        },
      })
      const opt = {
        ...this.ruleFormNew,
      }
      if (this.deviceTypeInfo.code === 'Cooperator') { // 合作商设备类型
        if (res[1]) {
          this.$message.success('保存成功')
          this.$emit('reload')
          this.dialogShow = false
          this.isActivateTool = false
          this.delDraw()
        }
        return
      }
      if (!opt.buildingId) delete opt.buildingId
      if (!opt.floorId) delete opt.floorId
      const [err2, res2] = await iotDeviceApi.updateIOTDeviceBuildingFloor({ body: opt })
      this.saveLoading = false
      if (res[1] && !err2) {
        this.$message.success('保存成功')
        this.$emit('reload')
        this.dialogShow = false
        this.isActivateTool = false
        this.delDraw()
      } else {
        this.$message.error('保存失败')
      }
    },
    // 编辑上传建筑楼层信息
    async editBuildingFloor() {
      const opt = {
        ...this.ruleFormNew,
      }
      console.log('123456', opt)
      const [err, res] = await iotDeviceApi.updateIOTDeviceBuildingFloor({ body: opt })
      if (!err && res) {
        console.log('12345', res)
      }
    },
    // 编辑时获取设备建筑、楼层下拉框
    async getBuild() {
      const data = {
        maxResultCount: 999,
        sceneId: this.modelFileId,
        skipCount: 0,
      }
      const [err, res] = await buildingApi.getList(data)
      if (!err && res) {
        console.log('12345', res)
        this.buildOption = res.items
      }
    },
    changeBuilding(val) {
      if (val === '') {
        this.ruleFormNew.buildingName = ''
        this.ruleFormNew.buildingId = ''
        this.ruleFormNew.floorName = ''
        this.ruleFormNew.floorId = ''
        this.floorOption = []
        return
      }
      this.ruleFormNew.buildingName = val
      const build =
        _.find(this.buildOption, (item) => {
          return item.name === val
        }) || ''
      console.log(build, '12345')
      this.ruleFormNew.buildingId = build.id || ''
      this.getFloor()
      this.ruleFormNew.floorName = ''
      this.ruleFormNew.floorId = ''
    },
    changeFloor(val) {
      this.ruleFormNew.floorName = val
      const floor =
        _.find(this.floorOption, (item) => {
          return item.name === val
        }) || ''
      this.ruleFormNew.floorId = floor.id || ''
    },
    async getFloor() {
      const data = {
        maxResultCount: 999,
        sceneId: this.modelFileId,
        skipCount: 0,
        buildingId: this.ruleFormNew.buildingId || '',
      }
      const [err, res] = await floorApi.getList(data)
      if (!err && res) {
        this.floorOption = res.items
      }
    },
    // 获取新form信息
    async getNewForm() {
      const id = this.detailRow.tag3DPositionRelationKey
      const [err, res] = await iotDeviceApi.get(id)
      if (!err && res) {
        this.ruleFormNew.id = res.id || ''
        this.ruleFormNew.buildingId = res.buildingId || ''
        this.ruleFormNew.floorId = res.floorId || ''
        this.ruleFormNew.buildingName = res.buildingName || ''
        this.ruleFormNew.floorName = res.floorName || ''
        this.ruleFormNew.relevanceDevices = res.relevanceDevices || ''
        console.log(this.ruleFormNew, '12345')
      }
    },
    // 清空关联
    relevanceDevicesClear() {
      this.ruleFormNew.relevanceDevices = ''
      this.$emit('relevanceDevices', this.ruleFormNew.relevanceDevices)
    },
    // 选择关联设备
    relevanceDevicesSelect() {
      this.$emit('open-device-detail')
    },
    // 重置
    dataReset() {
      this.$refs.ruleForm.resetFields()
    },
    // 返回上一个页面
    backPrevious() {
      this.$router.go(-1)
    },
    // 取消编辑(隐藏设备信息弹窗)
    cancelEdit() {
      this.$emit('on-cancel-dev-edit')
    },
    generateUUID() {
      let d = new Date().getTime()
      if (this.performance && typeof this.performance.now === 'function') {
        d += performance.now()
      }
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },
    // 强制刷新输入框
    inputUpdate() {
      this.$forceUpdate()
    },
    /**
     * @description: 添加坐标
     * @return {*}
     */
    async addPositionVertex() {
      this.ruleForm.points.push({
        id: '',
        xPoint: '0',
        yPoint: '0',
        zPoint: '0',
      })
      this.$forceUpdate()
    },
    // 移除围栏坐标
    async removePositionVertex(index) {
      this.ruleForm.points.splice(index, 1)
      this.$forceUpdate()
      if (this.player && this.player.Native) {
        this.drawArea()
      }
    },
    /**
     * @description: 点位数据变化时触发
     * @return {*}
     */
    changeAreaPosition() {
      if (this.timerOut) clearTimeout(this.timerOut)
      this.timerOut = setTimeout(async () => {
        if (this.player) {
          this.drawArea()
        }
      }, 500)
    },
    changeAreaHeight() {
      if (this.areaObject && this.player) {
        this.player.Native.ElectoronicRail.setHeight(this.areaObject, Number(this.railHeight))
      }
    },
    // 删除绘制的有效范围(供父组件使用)
    async delDraw() {
      // 判断是否有区域对象
      if (this.areaObject) {
        await this.player.Native.ElectoronicRail.destroy(this.areaObject)
      }
    },
    async drawArea() {
      if (this.ruleForm.points && this.modelLoaded) {
        // 判断是否有区域对象
        if (this.areaObject) {
          await this.player.Native.ElectoronicRail.destroy(this.areaObject)
        }
        // 初始化
        this.areaObject = await this.player.Native.ElectoronicRail.create(
          this.generateUUID(),
          this.railHeight || 1
        )
        await this.setAreaStyle()
        // 实现有边的效果
        this.player.Native.ElectoronicRail.setEditMode(true)
        this.player.Native.ElectoronicRail.setEditType(0)
        _.forEach(this.ruleForm.points, (item) => {
          this.player.Native.ElectoronicRail.addFencePillar(this.areaObject, [
            item.xPoint,
            item.yPoint,
            item.zPoint,
          ])
        })
        await this.player.Native.ElectoronicRail.setSelect(this.areaObject, true)
        if (this.isActivateTool) {
          this.player.Native.ElectoronicRail.setEditMode(true)
        }
      }
    },
    async setAreaStyle() {
      let color
      if (this.ruleForm.threeDMonitorRangeColor) {
        color = this.hex2rgba(this.ruleForm.threeDMonitorRangeColor)
      } else {
        color = {
          r: 255,
          g: 255,
          b: 255,
          a: 125,
        }
      }

      const imagePtr = await this.player.Native.ElectoronicRail.createTextureByImage(
        `rgba:${color.r},${color.g},${color.b},${color.a}`
      )
      // 隐藏柱子
      this.player.Native.ElectoronicRail.setFencePillarVisible(this.areaObject, false)
      // 显示盖子
      this.player.Native.ElectoronicRail.setFenceCapVisible(this.areaObject, true)
      // 设置盖子的颜色
      this.player.Native.ElectoronicRail.setFenceCapColor(this.areaObject, [
        color.r / 255,
        color.g / 255,
        color.b / 255,
        // color.a / 255,
        0,
      ])
      // 设置围栏的材质为图片
      this.player.Native.ElectoronicRail.setWallOutsideTexture(this.areaObject, imagePtr)
      this.player.Native.ElectoronicRail.setWallInsideTexture(this.areaObject, imagePtr)
    },
    async activateTool() {
      this.isActivateTool = !this.isActivateTool
      if (this.isActivateTool) {
        this.createPillarPos = []
        this.player.Native.ElectoronicRail.setEditMode(true)
        this.player.Native.ElectoronicRail.setEditType(2)
        if (this.ruleForm.points.length <= 1) {
          this.areaObject = await this.player.Native.ElectoronicRail.createByMouse(
            this.generateUUID(),
            1,
            this.railHeight || 1
          )
          // 设置样式
          await this.setAreaStyle()
          this.player.Native.ElectoronicRail.setSelect(this.areaObject, true)
          this.player.Native.ModelTree.EventBrowseRClick.connect(this.watchRightKey)
          this.player.Native.ModelTree.EventBrowseLClick.connect(this.watchLeftKey)
        }
      } else {
        this.player.Native.ModelTree.EventBrowseRClick.disconnect(this.watchRightKey)
        this.player.Native.ModelTree.EventBrowseLClick.disconnect(this.watchLeftKey)
        this.player.Native.ElectoronicRail.setEditType(0)
        this.player.Native.ElectoronicRail.setEditMode(false)
      }
    },
    watchRightKey({ pos }) {
      if (this.ruleForm.points.length === 2) {
        this.ruleForm.points.push({
          xPoint: `${pos[0]}`,
          yPoint: `${pos[1]}`,
          zPoint: `${pos[2]}`,
        })
      }
      if (this.ruleForm.points.length < 3) return
      this.player.Native.ModelTree.EventBrowseLClick.disconnect(this.watchLeftKey)
      this.player.Native.ModelTree.EventBrowseRClick.disconnect(this.watchRightKey)
      this.isActivateTool = false // 右键结束绘制, 取消手动绘制
    },
    async watchLeftKey({ pos }) {
      this.createPillarPos.push({ xPoint: `${pos[0]}`, yPoint: `${pos[1]}`, zPoint: `${pos[2]}` })
      const pillarCount = await this.player.Native.ElectoronicRail.fencePillarCount(this.areaObject)
      // 鼠标点击右键时触发
      if (this.createPillarPos.length > pillarCount) {
        this.activateTool()
        return
      }
      this.ruleForm.points = _.cloneDeep(this.createPillarPos)
      this.$forceUpdate()
    },
    /**
     * @description: hex转化成rgba
     * @param {*} hex
     * @return {*}
     */
    hex2rgba(hex) {
      const result = {}
      result.r = Number(parseInt(hex.substring(1, 3), 16)) || 0
      result.g = Number(parseInt(hex.substring(3, 5), 16)) || 0
      result.b = Number(parseInt(hex.substring(5, 7), 16)) || 0
      result.a = Number(parseInt(hex.substring(7), 16)) || 255
      return result
    },
    /**
     * 获取图片内容并进行预览
     * @param {*} fileId 文件id
     */
    async getImgContent(fileId) {
      this.currentIconUrl = `${this.fileUrl}${fileId}`
    },
  },
  created() {
    this.initData()
  },
}
</script>

<style lang="scss" scoped>
.point-set-dialog {
  position: absolute;
  bottom: 0;
  left: 5px;
  right: 0;
  z-index: 99;
  padding: 10px 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  background-color: var(--contentBgColor);
  .form-height {
    height: 400px;
    overflow: auto;
  }
}

::v-deep {
  .el-form-item {
    margin-bottom: 5px;
  }
}

.width-80 {
  width: 80%;
}

.width-50 {
  width: 50%;
}
</style>
